<template>
  <div class="footer-newsletter-form-success-message__wrapper">
    <div class="footer-newsletter-form-success-message__title">
      <div class="footer-newsletter-form-success-message_title-icon">
        <a-icon
          :icon="ICON.SUCCESS_ROUND_BLUE"
          :width="30"
          :height="30"
          fill="#fff"
          no-hover
        />
      </div>
      <p
        class="footer-newsletter-form-success-message__title-message subtitle-3 white"
      >
        {{ formSettings.SuccessMessageTitle }}
      </p>
    </div>

    <p
      class="footer-newsletter-form-success-message__description text-small white"
    >
      {{ formSettings.SuccessMessageText }}
    </p>
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon'
import { propValidator, PROP_TYPES } from '@/utils/validators'

export default {
  name: 'FooterNewsletterFormSuccessMessage',
  components: { AIcon },
  props: {
    formSettings: propValidator([PROP_TYPES.OBJECT], false, () => ({}))
  },
  data() {
    return {
      ICON
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-newsletter-form-success-message__title {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  gap: 8px;
}

.footer-newsletter-form-success-message__description {
  max-width: 272px;
}
</style>
